// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2XZuw","notes":"Notes_notes__Tv9Mq"};